export default { sha: '96049a839ea68a68932d37559b38d7e56fb58ff6', buildNumber: 'undefined' }
